import { multipleDtoToMultiple, TableScheduleListDtoToTableScheduleCancelItem, TableScheduleListDtoToTableScheduleList, createScheduleDtoToCreateSchedule, scheduleServiceListDtoToScheduleServiceList, scheduleVehicleDtoToScheduleVehicle, MultipleToMultipleDto, } from '../../mappers/schedule';
import { getCurrentGroupId, getManagerId } from './../../utils/functions';
import { api } from './api';
export const ScheduleApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getScheduleTableData: builder.query({
            query: (params) => ({
                method: 'get',
                url: `/api/Agendamento/${getCurrentGroupId()}`,
                params: {
                    dataInicio: params.startDate || '2022-03-23',
                    dataFim: params.endDate || new Date().toISOString(),
                    quantidade: params.quantity || 5,
                    pagina: params.page || 1,
                    busca: params.term || null,
                },
            }),
            transformResponse: (response) => TableScheduleListDtoToTableScheduleList(response),
        }),
        listServices: builder.query({
            query: (params) => ({
                method: 'get',
                url: `/api/Agendamento/Servicos/${getCurrentGroupId()}`,
                params: {
                    nivel1: params.firstLevel || null,
                    nivel2: params.secondLevel || null,
                    nivel3: params.thirdLevel || null,
                },
            }),
            transformResponse: (response) => scheduleServiceListDtoToScheduleServiceList(response),
        }),
        listPlate: builder.query({
            query: (params) => ({
                url: `api/Agendamento/GetKm/${getCurrentGroupId()}`,
                params: {
                    placa: params.plate,
                    gestorId: getManagerId(),
                },
            }),
            transformResponse: (response) => scheduleVehicleDtoToScheduleVehicle(response),
        }),
        cancelSchedule: builder.mutation({
            query: body => ({
                method: 'post',
                url: `api/Agendamento/${getCurrentGroupId()}/Cancelar`,
                data: TableScheduleListDtoToTableScheduleCancelItem({
                    ...body,
                    managerId: getManagerId(),
                }),
            }),
        }),
        createNewSchedule: builder.mutation({
            query: body => ({
                url: `api/Agendamento/Solicitar/${getCurrentGroupId()}`,
                method: 'post',
                data: createScheduleDtoToCreateSchedule(body),
            }),
        }),
        checkMultiplePlates: builder.mutation({
            query: data => ({
                url: `api/Agendamento/GetQuilometragemEmLote/${getCurrentGroupId()}`,
                method: 'post',
                data,
            }),
            transformResponse: (response) => multipleDtoToMultiple(response),
            transformErrorResponse: (response) => multipleDtoToMultiple(response.data),
        }),
        createMultipleSchedules: builder.mutation({
            query: data => ({
                url: `api/Agendamento/SolicitarEmLote/${getCurrentGroupId()}`,
                method: 'post',
                data: MultipleToMultipleDto(data),
            }),
        }),
    }),
});
export const { useGetScheduleTableDataQuery, useLazyGetScheduleTableDataQuery, useCancelScheduleMutation, useCreateNewScheduleMutation, useListServicesQuery, useLazyListServicesQuery, useListPlateQuery, useLazyListPlateQuery, useCreateMultipleSchedulesMutation, useCheckMultiplePlatesMutation, } = ScheduleApi;
